<section [formGroup]="form">
  <div class="mat-body-2">
    {{field.label}}
    @if (isRequired) {
      <span style="color: red;">*</span>
    }
  </div>
  <mat-form-field [appearance]="appearance" [class.custom-hints]="isValid && outOfRange">
  @switch (field.type) {
    @case ('number') {
      <input
        onlyDigits
        matInput
        type="string"
        autocomplete="off"
        [formControlName]="field.id"
        [errorStateMatcher]="matcher"
        />
    }
    @case ('string') {
      <input matInput type="text" autocomplete="off" [formControlName]="field.id" [errorStateMatcher]="matcher" />
    }
    @case ('textarea') {
      <textarea matInput rows="4" [formControlName]="field.id" [errorStateMatcher]="matcher"></textarea>
    }
  }

  @if (field?.uom && isValid && !outOfRange) {
    <span class="mat-body-2" matSuffix>({{field?.uom}})</span>
  }

  @if (!isValid) {
    <mat-icon matSuffix color="warn">error</mat-icon>
  }
  @if (!isValid) {
    <mat-error>{{getErrorMessage()}}</mat-error>
  }

  @if (isValid && !outOfRange && hint?.value) {
    <mat-hint align="start">
      @switch (hint?.type) {
        @case ('estimate') {
          Estimate: {{hint.value}}
        }
        @case ('range') {
          @if (Util.isNumeric(hint.value?.min) && Util.isNumeric(hint.value?.max)) {
            Range: {{hint.value?.min}} - {{hint.value?.max}}
          }
          @if (Util.isNumeric(hint.value?.min) && !Util.isNumeric(hint.value?.max)) {
            Range min: {{hint.value?.min}}
          }
          @if (Util.isNumeric(hint.value?.max) && !Util.isNumeric(hint.value?.min)) {
            Range max: {{hint.value?.max}}
          }
        }
      }
    </mat-hint>
  }
  @if (!outOfRange && prev) {
    <mat-hint align="end">Previous: {{prev}}</mat-hint>
  }

  @if (isValid && outOfRange) {
    <mat-hint>
      @if (Util.isNumeric(range.min) && Util.isNumeric(range.max)) {
        Out of range, value should be in between {{range.min}} and {{range.max}}
      }
      @if (Util.isNumeric(range.min) && !Util.isNumeric(range.max)) {
        Out of range, value should be greater than or equal to {{range.min}}
      }
      @if (!Util.isNumeric(range.min) && Util.isNumeric(range.max)) {
        Out of range, value should be lesser than or equal to {{range.max}}
      }
    </mat-hint>
  }
  @if (isValid && outOfRange) {
    <mat-icon matSuffix class="hint-icon">warning</mat-icon>
  }

</mat-form-field>
</section>
